import script from "./ControlButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ControlButton.vue?vue&type=script&setup=true&lang=ts"

import "./ControlButton.vue?vue&type=style&index=0&id=32de1aad&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32de1aad"]])

export default __exports__